import React from "react";
import { findWrapperNode } from "../../../../core/helpers";
import { EditorPopup } from "../../../popup";
import { EditorCalloutMenu } from "../EditorCalloutMenu/EditorCalloutMenu";
export const EditorCalloutMenuPluginView = ({ view }) => {
    const target = findWrapperNode(view, view.state.schema.nodes.callout);
    if (!target) {
        return null;
    }
    const handleCalloutTypeChange = (type) => {
        const { node, pos } = target;
        const tr = view.state.tr;
        tr.setNodeMarkup(pos, null, { ...node.attrs, type });
        view.dispatch(tr);
        view.focus();
    };
    const handleRemove = () => {
        const { node, pos } = target;
        const state = view.state;
        const tr = state.tr.deleteRange(pos, pos + node.nodeSize);
        view.dispatch(tr);
        view.focus();
    };
    const attrs = target.node.attrs;
    return (React.createElement(EditorPopup, { view: view, referenceElement: view.nodeDOM(target.pos), placement: "bottom" },
        React.createElement(EditorCalloutMenu, { type: attrs.type, onTypeChange: handleCalloutTypeChange, onRemove: handleRemove })));
};
